/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { forwardRef } from "react";

import WarningIcon from "@material-ui/icons/Warning";
import amber from "@material-ui/core/colors/yellow";

const AlertsIcon = forwardRef(({ color, style, ...props }, ref) => (
  <WarningIcon
    fontSize="small"
    ref={ref}
    style={{ color: color ? color : amber[700], fontSize: "18px", ...style }}
    {...props}
  />
));

export default AlertsIcon;
